import DroppedDevicesModal from './dropped-devices-modal.connect'

export default DroppedDevicesModal
